import { render, staticRenderFns } from "./BadgeErp.vue?vue&type=template&id=2b02e7d8&scoped=true"
import script from "./BadgeErp.vue?vue&type=script&lang=js"
export * from "./BadgeErp.vue?vue&type=script&lang=js"
import style0 from "./BadgeErp.vue?vue&type=style&index=0&id=2b02e7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02e7d8",
  null
  
)

export default component.exports